import React from 'react';

export default function HeroPara() {
  return (
    <div className='flex-center hero-para-wrapper'>
    <div className="flex circle-container">
    <span className="circle"></span>
    <span className="circle"></span>
    <span className="circle"></span>
    </div>
      <p className="hero-para">A Full Stack Web Developer, looking for opportunities as a Full Stack Developer/ Frontend Developer / Backend Developer. <br />
      <span className='hero-title'>Preference</span> React Frontend development. <br />
      <span className='hero-title'>Strengths</span> Logical thinking, problem solving,debugging and creating impeccable layouts.</p>      
    </div>
  );
}
